import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosNewInstance } from "../../config/Api.js";
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";
import "./UserForm.scss";
import LangData from "../common/LangData.js";
import { fetchData } from "../../utils/utils.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export const UserForm = ({
  editUser,
  onFormSubmit,
  roles,
  handleFormCancel,
}) => {
  const history = useHistory();
  //   let defaultRole = [
  //     {
  //         "name": "Admin",
  //         "id": 1
  //     },
  //     {
  //         "name": "Agent",
  //         "id": 4
  //     },
  //     {
  //         "name": "Bank Partners",
  //         "id": 3
  //     },
  //     {
  //         "name": "LIC Employee",
  //         "id": 2
  //     }
  // ]
  // const [showPassword, setShowPassword] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      empId: "",
      userId: "",
      phone: "",
      joining_date: "",
      role: "",
      status: "0",
      password: "",
      retypePassword: "",
      email: "",
      designation: "",
      branch_code: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("User Name is required"),
      empId: Yup.string().nullable(),
      userId: Yup.string().required("User ID is required"),
      phone: Yup.string()
        .required("Phone number is required")
        .matches(/^\d{11}$/, "Phone number must be exactly 11 digits"),
      email: Yup.string()
        .email("Invalid email format")
        .matches(/@/, "Email must contain an '@' symbol"),
      role: Yup.string().required("Role is required"),
      designation: Yup.string(),
      joining_date: Yup.date().nullable(),
      status: Yup.string().required("Status is required"),
      password: Yup.string().test(
        "password-validation",
        "Password must be at least 8 characters, include one uppercase letter, one number, and one special character",
        function (value) {
          // In edit mode
          if (editUser?.id) {
            // Skip validation if password matches existing password
            if (value === editUser.password) return true;
            // Skip validation if empty
            if (!value || value === "") return true;
            // Only validate if new password is entered
            return /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value);
          }
          // In create mode
          if (!value) return false;
          return /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value);
        }
      ),
      retypePassword: Yup.string().test(
        "retype-password-validation",
        "Passwords must match",
        function (value) {
          const { password } = this.parent;
          // In edit mode
          if (editUser?.id) {
            // Skip validation if password matches existing password
            if (password === editUser.password) return true;
            // Skip validation if no new password
            if (!password || password === "") return true;
            // Validate match only if new password is entered
            return value === password;
          }
          // In create mode
          if (!password) return false;
          return value === password;
        }
      ),
      branch_code: Yup.string().when("role", {
        is: (role) => role === "3" || role === 3,
        then: () =>
          Yup.string()
            .required("Branch code is required for Bank Partners role")
            .matches(/^[a-zA-Z0-9]{9}$/, "Branch code must be exactly 9 characters"),
        otherwise: () =>
          Yup.string()
            .nullable()
            .notRequired()
            .transform((value) => (!value ? null : value)),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log("values 322222222", values)
      try {
        // Add validation for branch code before submission
        if ((values.role === "3" || values.role === 3) && !values.branch_code?.trim()) {
          formik.setFieldError("branch_code", "Branch code is required for Bank Partners role");
          return;
        }

        const url = editUser?.id ? `update-users` : "store-users";
        const payload = {
          en_first_name: values.name,
          emp_id: values.empId,
          login_id: values.userId,
          mobile: values.phone,
          email: values?.email ?? null,
          designation: values.designation,
          joining_date: values.joining_date,
          role_id: values.role,
          status: values.status,
          password: values.password || undefined,
          branch_code:
            values.role === "3" || values.role === 3
              ? values.branch_code?.trim()
              : null,
          ...(editUser?.id && {
            id: editUser.id,
            password: values.password || undefined,
          }),
        };

        const result = await fetchData(url, {
          ...payload,
        });

        if (result.success && result.data?.status === 1) {
          toast.success(
            editUser?.id
              ? "User updated successfully!"
              : "User added successfully!"
          );
          resetForm();
          onFormSubmit();
        } else {
          if (result.data?.message) {
            if (typeof result.data.message === "object") {
              Object.keys(result.data.message).forEach((key) => {
                if (Array.isArray(result.data.message[key])) {
                  formik.setFieldError(key, result.data.message[key][0]);
                } else {
                  formik.setFieldError(key, result.data.message[key]);
                }
              });
              const firstError = Object.values(result.data.message)[0];
              if (Array.isArray(firstError)) {
                toast.error(firstError[0]);
              } else {
                toast.error(firstError);
              }
            } else {
              toast.error(result.data.message);
            }
          } else {
            toast.error(
              editUser?.id ? "Failed to update User!" : "Failed to add user!"
            );
          }
        }
      } catch (error) {
        console.error("Form submission error:", error);
        if (error.message === "User not authenticated") {
          localStorage.removeItem("authToken");
          history.push("/login");
        } else {
          toast.error("An unexpected error occurred. Please try again.");
        }
      }
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (editUser) {
      formik.setValues({
        name: editUser?.en_first_name || "",
        empId: editUser?.emp_id || "",
        userId: editUser?.login_id || "",
        phone: editUser?.mobile || "",
        role: editUser?.role_id?.toString() || "",
        email: editUser?.email || "",
        designation: editUser?.designation || "",
        password: "",
        retypePassword: "",
        branch_code: editUser?.branch_code || "",
        joining_date: editUser?.joining_date
          ? new Date(editUser.joining_date)
          : null,
        status: editUser?.status?.toString() || "1",
      });

      // Force validation after setting values
      if (editUser.role_id === 3 || editUser.role_id === "3") {
        formik.validateField("branch_code");
      }
    }
  }, [editUser]);

  useEffect(() => {
    if (editUser?.id && formik?.values?.password) {
      formik.setFieldValue("retypePassword", formik?.values?.password);
    }
  }, [formik?.values?.password]);

  console.log("values 322222222 values", formik?.values)
  // console.log("formik?.values", formik?.values, formik?.errors);
  return (
    <div className="container user__form__area mt-4">
      <div className="card shadow-sm">
        <div
          className="card-header"
          style={{ backgroundColor: "#004e8f", color: "white" }}
        >
          <h3 className="mb-0">
            {Object.keys(editUser)?.length > 0 ? "Update User" : "Add New User"}
          </h3>
        </div>
        <div className="card-body">
          <form onSubmit={formik.handleSubmit}>
            <div className="row g-3">
              {/* User Name */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="name" className="form-label">
                  <LangData keyname="label_name" />{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={`form-control ${formik.touched.name && formik.errors.name
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="invalid-feedback">{formik.errors.name}</div>
                )}
              </div>

              {/* Employee ID */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="empId" className="form-label">
                  Employee ID
                </label>
                <input
                  type="text"
                  id="empId"
                  name="empId"
                  className={`form-control ${formik.touched.empId && formik.errors.empId
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.empId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empId && formik.errors.empId && (
                  <div className="invalid-feedback">{formik.errors.empId}</div>
                )}
              </div>

              {/* User ID */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="userId" className="form-label">
                  <LangData keyname="label_customer_id" />{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="userId"
                  name="userId"
                  className={`form-control ${formik.touched.userId && formik.errors.userId
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.userId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.userId && formik.errors.userId && (
                  <div className="invalid-feedback">{formik.errors.userId}</div>
                )}
              </div>

              {/* Phone */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="phone" className="form-label">
                  <LangData keyname="label_mobile" />{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  className={`form-control ${formik.touched.phone && formik.errors.phone
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    formik.setFieldValue("phone", value);
                  }}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.phone && formik.errors.phone && (
                  <div className="invalid-feedback">{formik.errors.phone}</div>
                )}
              </div>

              {/* Role */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="role" className="form-label">
                  <LangData keyname="label_user_type" />{" "}
                  <span className="text-danger">*</span>
                </label>
                <select
                  id="role"
                  name="role"
                  style={{ height: "43px" }}
                  className={`form-select w-100 border ${formik.touched.role && formik.errors.role
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select a Role</option>
                  {roles?.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
                {formik.touched.role && formik.errors.role && (
                  <div className="invalid-feedback">{formik.errors.role}</div>
                )}
              </div>
              {/* Branch Code - Only show when role is 3 */}
              {(formik.values.role === "3" || formik.values.role === 3) && (
                <div className="col-md-6" style={{ marginBottom: "0px" }}>
                  <label htmlFor="branch_code" className="form-label">
                    <LangData keyname="label_branch_code" />
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="branch_code"
                    name="branch_code"
                    maxLength={9}
                    placeholder="Enter 9 characters branch code"
                    className={`form-control ${formik.touched.branch_code && formik.errors.branch_code
                      ? "is-invalid"
                      : ""
                      }`}
                    value={formik.values.branch_code || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                      formik.setFieldValue("branch_code", value);
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.branch_code && formik.errors.branch_code && (
                    <div className="invalid-feedback">
                      {formik.errors.branch_code}
                    </div>
                  )}
                </div>
              )}
              {/* Email */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="email" className="form-label">
                  <LangData keyname="label_policy_holder_email" />{" "}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className={`form-control ${formik.touched.email && formik.errors.email
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                )}
              </div>

              {/* Designation */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="designation" className="form-label">
                  <LangData keyname="label_designation" />{" "}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  type="text"
                  id="designation"
                  name="designation"
                  className={`form-control ${formik.touched.designation && formik.errors.designation
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.designation}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.designation && formik.errors.designation && (
                  <div className="invalid-feedback">
                    {formik.errors.designation}
                  </div>
                )}
              </div>

              {/* Joining Date */}
              <div
                className="col-md-6 userForm__datePicker"
                style={{ marginBottom: "0px" }}
              >
                <label htmlFor="joining_date" className="form-label">
                  <LangData keyname="joining_date" />{" "}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <div>
                  <DatePicker
                    id="joining_date"
                    name="joining_date"
                    selected={formik.values.joining_date}
                    onChange={(date) =>
                      formik.setFieldValue("joining_date", date)
                    }
                    onBlur={formik.handleBlur}
                    className={`form-control ${formik.touched.joining_date && formik.errors.joining_date
                      ? "is-invalid"
                      : ""
                      }`}
                    style={{ width: "100%" }}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select joining date"
                    autoComplete="off"
                  />
                </div>
                {formik.touched.joining_date && formik.errors.joining_date && (
                  <div className="invalid-feedback">
                    {formik.errors.joining_date}
                  </div>
                )}
              </div>

              {/* Status */}
              <div className="col-md-6" style={{ marginBottom: "0px" }}>
                <label htmlFor="status" className="form-label">
                  <LangData keyname="label_status" />{" "}
                  <span className="text-danger">*</span>
                </label>
                <select
                  id="status"
                  name="status"
                  className={`form-select form-control ${formik.touched.status && formik.errors.status
                    ? "is-invalid"
                    : ""
                    }`}
                  value={formik.values.status}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select Status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
                {formik.touched.status && formik.errors.status && (
                  <div className="invalid-feedback">{formik.errors.status}</div>
                )}
              </div>

              {/* Password */}
              <div
                className="col-md-6"
                style={{ marginBottom: "0px", position: "relative" }}
              >
                <label htmlFor="password" className="form-label">
                  <LangData keyname="label_new_password" />{" "}
                  {!editUser?.id && <span className="text-danger">*</span>}
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  className={`form-control ${formik.touched.password && formik.errors.password
                    ? "is-invalid"
                    : ""
                    }`}
                  // value={formik.values.password}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {/* {!editUser?.id && ( */}
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "36px",
                    top: "45px",
                    cursor: "pointer",
                    color: "#999",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
                {/* )} */}
                {formik.touched.password && formik.errors.password && (
                  <div className="invalid-feedback">
                    {formik.errors.password}
                  </div>
                )}
              </div>

              {/* Re-type Password */}
              {!editUser?.id && (
                <div
                  className="col-md-6"
                  style={{ marginBottom: "0px", position: "relative" }}
                >
                  <label htmlFor="retypePassword" className="form-label">
                    <LangData keyname="label_confirm_password" />{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="retypePassword"
                    name="retypePassword"
                    className={`form-control ${formik.touched.retypePassword &&
                      formik.errors.retypePassword
                      ? "is-invalid"
                      : ""
                      }`}
                    value={formik.values.retypePassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <span
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      right: "36px",
                      top: "45px",
                      cursor: "pointer",
                      color: "#999",
                    }}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                  {formik.touched.retypePassword &&
                    formik.errors.retypePassword && (
                      <div className="invalid-feedback">
                        {formik.errors.retypePassword}
                      </div>
                    )}
                </div>
              )}
            </div>

            <div className="mt-4 float-end">
              <button
                type="button"
                className="btn btn-secondary px-4 py-2 mx-2"
                style={{ height: "40px" }}
                onClick={handleFormCancel}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary px-4 py-2"
                style={{ height: "40px" }}
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting
                  ? "Submitting..."
                  : editUser?.id
                    ? "Update User"
                    : "Add User"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
